var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoOttryFooterText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 41 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.68.216a6.311 6.311 0 107.729 4.463 1.019 1.019 0 10-1.967.527 4.274 4.274 0 01-3.023 5.233 4.274 4.274 0 01-5.236-3.02 4.274 4.274 0 014.732-5.338A1.02 1.02 0 007.201.063 6.293 6.293 0 004.68.216z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.918 1.833a1.074 1.074 0 00.395 1.473 1.075 1.075 0 001.472-.395 1.075 1.075 0 00-.394-1.472 1.075 1.075 0 00-.818-.108l-.105.034c-.239.09-.43.26-.55.468z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.057 6.296h1.902V4.208h-1.902V1.852l-2.171.656v1.7H13.42v2.088h1.465v3.501c0 1.156.303 1.959.909 2.408.617.448 1.672.589 3.164.42v-1.97c-.415.023-.763.029-1.043.018-.281-.023-.494-.101-.64-.236-.146-.135-.219-.348-.219-.64V6.296z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.074 6.296h1.902V4.208h-1.902V1.852l-2.172.656v1.7h-1.464v2.088h1.464v3.501c0 1.156.303 1.959.91 2.408.616.448 1.671.589 3.164.42v-1.97c-.415.023-.763.029-1.044.018-.28-.023-.493-.101-.64-.236-.145-.135-.218-.348-.218-.64V6.296z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.81 5.656c.202-.538.533-.942.994-1.212a3.1 3.1 0 011.565-.404v2.424c-.662-.078-1.257.056-1.784.404-.517.348-.775.926-.775 1.734v4.023H26.64V4.208h2.171v1.448z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.63 4.208h-2.322l-1.869 5.657-2.188-5.657h-2.374l3.451 8.148c-.202.572-.477.988-.825 1.246-.336.258-.797.381-1.38.37v2.02c1.077.056 1.975-.19 2.693-.74.73-.54 1.313-1.415 1.751-2.627l3.064-8.417z",
    fill: "currentColor"
  })));
}

export default SvgLogoOttryFooterText;